
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Hero from '../src/pages/Hero';
import Profile from '../src/pages/Profile';
import Header from '../src/Components/Header';
import Login from './pages/Login';
import Auth from './pages/Auth';
import Admin from './pages/Admin';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import PrivateProfile from './pages/PrivateProfile'
import { useLocation } from 'react-router-dom';
//import InstallBanner from '../src/Components/InstallBanner';
//import Footer from "../src/Components/Footer"

function AppLayout() {
  const location = useLocation();
  const showHeader = !location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {showHeader ? <Header /> : null}
      {/* <InstallBanner /> */}
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/home" element={<PrivateProfile />} />
        <Route path="/profile/:profileId" element={<Profile />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/terms-condition" element={<Terms/>} />
      </Routes>
      {/* <Footer /> */}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
